import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { faqs } from '../data/faqs';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-4 bg-dark-card" data-id="element-70" data-mp="1hdupklvgf9bb">
      <div className="max-w-3xl mx-auto" data-id="element-71" data-mp="1cf9ka81chzg0">
        <div className="text-center mb-16" data-id="element-72" data-mp="1cgb719rq4adk">
          <h2 className="text-3xl md:text-5xl font-serif font-bold" data-id="element-73" data-mp="2a2s3ydwjolys">❓ Questions fréquentes</h2>
        </div>
        <div className="space-y-4" data-id="element-74" data-mp="252vzkdjxqsip">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={faq.q} className="bg-black border border-dark-border rounded-xl overflow-hidden" data-id="element-75" data-mp="2028156tdn9eg" data-mpi={index}>
                <button type="button" className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none focus-visible:ring-2 focus-visible:ring-gold" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} data-id="element-76" data-mp="1v72da2gezknq">
                  <span className="font-bold text-lg text-white pr-8" data-id="element-77" data-mp="1pnct7jpewk7j">{faq.q}</span>
                  <ChevronDown className={`text-gold transition-transform duration-300 shrink-0 ${isOpen ? 'rotate-180' : ''}`} data-id="element-78" data-mp="1apsuuvn0tnac" />
                </button>
                <AnimatePresence initial={false} data-id="element-79" data-mp="1fn2kocebo0yp">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-80" data-mp="11wgwq9a0h0ty">
                      <div className="px-6 pb-5 text-gray-300 border-t border-dark-border/50 pt-4" data-id="element-81" data-mp="wxcl7bzm6r0g">{faq.a}</div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}